/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getInvoices(state) {
		return state.Invoices;
	},
	getInvoicesTotal(state) {
		return state.InvoicesTotal;
	},
	getSizePdf(state) {
		return state.sizePdf;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	},
	InvoiceSearch(state) {
		return state.InvoiceSearch;
	},
	DowloadEmails(state) {
		return state.DowloadEmails;
	},
	InvoiceInfoXml(state) {
		return state.InvoiceInfoXml;
	},
	CostTypes(state) {
		return state.CostTypes;
	},
	CostTypeByTimes(state) {
		return state.CostTypeByTimes;
	}
};
